import React, { useState } from 'react'
import {
  ContentContainer,
  TabContent,
  TabHeadingContainer
} from '../../components'
import { FeedTabs } from '../../types'

export const FeedPage = () => {
  const [selectedTab, setSelectedTab] = useState<FeedTabs>(FeedTabs.FOR_YOU)

  return (
    <div style={{ backgroundColor: 'whitesmoke' }}>
      <TabHeadingContainer
        selectedTab={selectedTab}
        //for later if we wanted to active other tabs
        // setSelectedTab={setSelectedTab}
        setSelectedTab={() => {}}
      />
      <TabContent>
        <ContentContainer queryKey={selectedTab} />
      </TabContent>
    </div>
  )
}
